// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const dashboardApi = baseApi.injectEndpoints({
  reducerPath: "dashboardApi",
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: () => {
        return {
          url: `dashboard`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDashboardQuery } = dashboardApi;
